<template>
  <div>
    <div class="centered-header">
      <h4 class="ui header" style="color: #092442;">
        <i class="pencil alternate icon"></i>
        <div class="content">
          Medical Tests
        </div>
      </h4>
    </div>
    <div class="ui divider"></div>
    <div v-if="medicalAnalysis && medicalAnalysis.length > 0 ">
      <div class="ui primary button" style="background-color: #092442"
           @click="showModal()"
            v-if="canAdd">
        {{ $t('addMedicalAnalysis') }}
      </div>

      <abstractTable :columns="medicalAnalysisColumns" :data="apiMedicalAnaylsis"
                     :classes="'ui very compact left aligned celled table'">
      </abstractTable>
    </div>

    <div v-else>
      <div class="ui placeholder segment" style="margin-bottom: 50px">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          {{ $t('noMedicalAnalysisHaveBeenAddedYet') }}
        </div>
        <div class="ui primary button" style="background-color: #092442"
             @click="showModal()"
             v-if="canAdd">
          {{ $t('addMedicalAnalysis') }}
        </div>
      </div>
    </div>

    <div class="ui large longer modal" :id="'medical-analysis-' + reservationVisitId " style="margin-top: 20px !important;">
      <div class="header">{{ $t('addMedicalAnalysis') }}</div>

      <div class="scrolling content">
        <inputTable :columns="medicalAnalysisColumns"
                    :objectProps="medicalAnalysisProps"
                    :objectArray="objectArray"
                    @onChange="medicalAnalysisEventListenner"
                    :clearData="wantToClear">
        </inputTable>

      </div>
      <div class="actions">
        <div class="ui button"
             @click="hideModal()">
          {{ $t('discard') }}
        </div>

        <div class="ui blue button"
             style="background-color: #092442"
             @click="save()">
          {{ $t('save') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    inputTable: require('@/components/abstract_components/InputTable').default
  },
  props: {
    reservationVisitId: { type: Number, required: true },
    medicalAnalysis: { type: Array, default: () => [] },
    canAdd: { type: Boolean, default: false }
  },
  data () {
    return {
      wantToClear: false,
      medicalAnalysisProps: {
        baiscProps: [
          {
            name: 'name',
            defaultValue: ''
          },
          {
            name: 'result',
            defaultValue: ''
          }
        ],
        widths: {
          name: '20%',
          result: '80%'
        },
        inputType: {
          name: 'text',
          result: 'text'
        },
        placeholder: {
          name: this.$t('medicalAnalysisName'),
          result: this.$t('medicalAnalysisResult')
        }
      },
      objectArray: [
        {
          name: '',
          result: ''
        }
      ],
      addedMedicalAnalysis: []
    }
  },
  computed: {
    medicalAnalysisColumns () {
      return [
        { header: 'Name', fieldName: 'name', show: true, width: '35%' },
        { header: 'Result', fieldName: 'result', show: true }
      ]
    },
    apiMedicalAnaylsis () {
      let formalatedMedicalAnalysis = []

      window._.each(this.medicalAnalysis, medicalAnalyses => {
        formalatedMedicalAnalysis.push({
          name: medicalAnalyses.name,
          result: medicalAnalyses.result
        })
      })

      return formalatedMedicalAnalysis
    }
  },
  methods: {
    showModal () {
      $('#medical-analysis-' + this.reservationVisitId).modal('show')
    },
    medicalAnalysisEventListenner (event) {
      this.addedMedicalAnalysis = event.data
    },
    hideModal () {
      this.wantToClear = true
      $('#medical-analysis-' + this.reservationVisitId).modal('hide')
      this.$nextTick(() => {
        this.wantToClear = false
      })
    },
    save () {
      let listWithoutNullValues = window._.filter(this.addedMedicalAnalysis, medicalAnalyses => {
        return medicalAnalyses.name || medicalAnalyses.result
      })

      this.$http.post(`reservation_visits/${this.reservationVisitId}/add/medical/analysis`, {
        medical_analysis: listWithoutNullValues,
        clinic_id: this.getClinicId()
      }).then(response => {
        window._.forEach(response.data, medicalAnalyses => {
          this.medicalAnalysis.push(medicalAnalyses)
        })
        this.hideModal()
      })
    }
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/visits/visit_components/MedicalAnalysisPart.vue